export const LANDING = '/';
export const QUIZZES = '/quizzes';
